module.exports = __webpack_public_path__ + "static/homepage_new-87373257cf51a7737e70ba116860d3fd.png";